__turbopack_context__.v({
  "responsive-image": "ResponsiveImage-module-scss-module__dnGBoG__responsive-image",
  "responsive-image__img": "ResponsiveImage-module-scss-module__dnGBoG__responsive-image__img",
});
